<template>
  <div class="philips-content">
    <div v-for="(pitem, ii) in pageConfig" :key="ii">
      <PcSwiper
        :data="pitem.data"
        v-if="pitem.type == 'swiper' && $store.getters.isPC"
      ></PcSwiper>
      <MobileSwiper
        :data="pitem.data"
        v-if="pitem.type == 'swiper' && !$store.getters.isPC"
      ></MobileSwiper>
      <div class="index-banner" v-if="pitem.type == 'banner'">
        <img
          v-if="pitem.data && pitem.data.length"
          :src="pitem.data[0].imageUrl[0].url"
          @click="bannerEvent(pitem)"
          alt=""
        />
      </div>
      <div
        class="index-coupon-pc"
        v-if="
          pitem.type == 'coupon' &&
          $store.getters.isPC &&
          couponSort.includes(ii)
        "
      >
        <img
          v-if="pitem.data && pitem.data.length"
          :src="pitem.data[0].imageUrl[0].url"
          @click="couponEvent(pitem)"
          alt=""
        />
      </div>
      <div
        class="index-coupon-mo"
        v-if="
          pitem.type == 'coupon' &&
          !$store.getters.isPC &&
          couponSort.includes(ii)
        "
      >
        <img
          v-if="pitem.data && pitem.data.length"
          :src="pitem.data[0].imageUrl[0].url"
          @click="couponEvent(pitem)"
          alt=""
        />
      </div>
      <div
        v-if="$store.getters.isPC && pitem.type == 'products'"
        class="product-wrap"
      >
        <div class="shop_product" v-if="pitem.showtype == '1'">
          <IndexProSwiper :data="pitem"></IndexProSwiper>
        </div>
        <div class="shop_product" v-if="pitem.showtype != '1'">
          <h3 class="shop_product_title">猜你喜欢</h3>
          <div class="clearFix" style="padding-top: 20px">
            <div class="product-list2" v-if="pitem.imageUrl">
              <div
                :style="{
                  backgroundImage: 'url(' + pitem.imageUrl + ')',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  width: '100%',
                  height: isLogin ? '341px' : '368px'
                }"
              ></div>
            </div>
            <div
              v-for="(slide, index) in pitem.data"
              :key="index"
              class="product-list product-list2"
            >
              <router-link
                @click.native="toProduct(slide.id)"
                :to="`/product-detail?id=${slide.id}`"
                target="_blank"
              >
                <img :src="slide.pic" />
                <div class="product-content">
                  <!-- <el-rate disabled :value="5" :colors="{5: '#a2bf1b'}"></el-rate> -->
                  <p class="product-name" :title="slide.name">
                    {{ slide.name }}
                  </p>
                  <div class="price" v-if="isLogin">
                    <span
                      >￥<em>{{ slide.price | moneyFilters }}</em></span
                    >
                    <span
                      class="crossedPrice"
                      v-if="slide.crossedPrice != slide.price"
                      >￥<em>{{ slide.crossedPrice | moneyFilters }}</em></span
                    >
                  </div>
                  <div class="price" v-else>
                    <span class="tips"
                      >官方建议零售价：￥<em>{{
                        slide.crossedPrice | moneyFilters
                      }}</em></span
                    >
                    <!-- <p class="tips">登录/注册会员即可享受会员价</p> -->
                    <Tip></Tip>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!$store.getters.isPC && pitem.type == 'products'"
        class="product-wrap"
      >
        <MobileIndex
          :data="pitem.data"
          :url="pitem.imageUrl"
          :type="pitem.showtype"
        ></MobileIndex>
      </div>
    </div>
  </div>
</template>

<script>
import PcSwiper from '@/components/Swiper'
import MobileSwiper from '@/components/MobileSwiper'
import IndexProSwiper from '@/components/IndexProSwiper'
import MobileIndex from '@/components/MobileIndex'
import Tip from '@/components/Tip'
import request from '@/assets/js/request'
// import Swiper from 'swiper/js/swiper'
// import 'swiper/css/swiper.css'
import { mapActions } from 'vuex'
export default {
  name: 'Index',
  data() {
    return {
      pageConfig: [],
      loading: false,
      isLogin: this.$store.getters.status,
      swiperList: [],
      couponSort: []
    }
  },
  components: {
    PcSwiper,
    MobileSwiper,
    MobileIndex,
    IndexProSwiper,
    Tip
  },
  methods: {
    ...mapActions(['toLogin']),
    async init() {
      try {
        this.loading = true
        let res = await request(
          '/gateway/dictionary/dictionary/page/get?id=' + '111', // 111
          'get'
        )
        this.loading = false
        let data = JSON.parse(res.data.cfgJson)
        this.pageConfig = data
        this.searchCoupon()
        this.pageConfig.map((one, index) => {
          if (one.type == 'swiper') {
            this.swiperList = one.data
          } else if (one.type == 'products') {
            if (one.showtype == '1') {
              one.swiperItem = null
              one.name = 'products' + index
            }
          }
        })
      } catch (e) {
        this.loading = false
      }
    },
    bannerEvent(item) {
      // banner图点击事件
      let path = item.data[0].path
      if (path.urlType == 'product') {
        // 埋点开始
        philips.analytics.trackConversion ({
          name:"interaction",
          description:"link:banner:product-detail"
        })
        // 埋点结束
        this.$router.push(`/product-detail?id=${path.product.id}`)
      } else if (path.urlType == 'webUrl') {
        // 埋点开始
        philips.analytics.trackConversion ({
          name:"interaction",
          description:"link:banner:" + path.webUrl
        })
        // 埋点结束
        window.location.href = path.webUrl
      } else if (path.urlType == 'ownUrl') {
        // 埋点开始
        philips.analytics.trackConversion ({
          name:"interaction",
          description:"link:banner:" + path.ownUrl
        })
        // 埋点结束
        window.location.href = path.ownUrl
      } else if (path.urlType == 'page') {
        if (path.page.id == '111') {
          // 埋点开始
          philips.analytics.trackConversion ({
            name:"interaction",
            description:"link:banner:index"
          })
          // 埋点结束
          this.$router.push(`/index`)
        } else {
          // 埋点开始
          philips.analytics.trackConversion ({
            name:"interaction",
            description:"link:banner:decorate"
          })
          // 埋点结束
          this.$router.push(`/decorate?id=${path.page.id}`)
        }
      }
    },
    toProduct(id) {
      philips.analytics.trackConversion ({ 
        name:"prodview",
        products: id
      })
    },
    async couponEvent(item) {
      let coupon = item.data[0].path.coupon
      if (this.isLogin) {
        // 领取优惠券
        try {
          this.loading = true
          await request(
            `/gateway/activity/activity/coupon/applyCoupon`,
            'post',
            {
              couponId: coupon.id,
              userId: this.$store.getters.info.id,
              uniqueId: this.$store.getters.info.uniqueId
            }
          )
          this.loading = false
          this.message('领取成功!', 'success')
        } catch (e) {
          this.loading = false
        }
      } else {
        this.message('请先登录再领取!')
        this.toLogin()
      }
    },
    // 查询装修页面的优惠券是否有效
    async searchCoupon() {
      try {
        let { data } = await request(
          '/gateway/activity/activity/coupon-page/list/111',
          'get'
        )
        data.map((e) => {
          this.couponSort.push(e.sort)
        })
      } catch (e) {}
    },
    indexMeta() {
      let head = document.querySelector('head')
      let meta1 = document.createElement('meta')
      meta1.name = 'PHILIPS.METRICS.CATALOGTYPE'
      meta1.content = 'homepage'
      let meta2 = document.createElement('meta')
      meta2.name = 'PHILIPS.METRICS.PAGETYPE'
      meta2.content = 'content'
      let meta3 = document.createElement('meta')
      meta3.name = 'PHILIPS.METRICS.PAGENAME'
      meta3.content = 'homepage'
      /* eslint-disable */
      try {
        setTimeout(() => {
          philips.analytics.trackAjax({
            pagename: 'homepage'
          })
        }, 2000)
      } catch (error) {}
      /* eslint-enable */
      head.insertBefore(meta1, head.children[7])
      head.insertBefore(meta2, head.children[7])
      head.insertBefore(meta3, head.children[7])
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 因为列表有监听路由事件，从列表进到首页，这个时候先进到这儿，然后又会走到列表的watch，会造成meta显示不对
    setTimeout(() => {
      this.indexMeta()
    }, 1000)
  },
  destroyed() {
    this.$removeMeta.removeFunctionMeta()
  }
  // 代码监控结束
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.index-banner {
  margin: 0 auto 2vw;
  width: 100%;
  img {
    display: block;
    width: 100%;
  }
}
.index-coupon-pc {
  // width: 80vw;
  // margin: 0 auto 2vw;
  width: 100%;
  margin: 0 auto;
  img {
    display: block;
    width: 100%;
  }
}
.index-coupon-mo {
  width: 100%;
  margin: 0 auto;
  img {
    display: block;
    width: 100%;
  }
}
.product-wrap {
  width: 80vw;
  margin: 0 auto;
  // padding-bottom: 45px;
  .shop_product_title {
    font-size: 18px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0;
  }
}
@media only screen and (max-width: 1080px) {
  .product-wrap {
    width: 92vw;
  }
  .index-coupon-pc {
    width: 92vw;
  }
}
@media only screen and (min-width: 1500px) {
  .product-wrap {
    width: 70vw;
  }
  .index-coupon-pc {
    width: 70vw;
  }
}
@media only screen and (max-width: 768px) {
  .product-wrap {
    width: 94vw;
    .shop_product_title {
      font-size: 16px;
    }
  }
}
@media only screen and (min-width: 769px) {
  .philips-content {
    > div:first-child {
      margin-bottom: 20px;
    }
    > div:not(:first-child) {
      .product-wrap {
        .shop_product {
          .shop_product_title {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Index.vue